import dom from "../../../../common/ts/core/dom";
import location from "../../../../common/ts/core/location";
import {serviceContainer} from "../../serp/SerpServiceContainerFactory"
import {TrovitSerpData} from "../../serp/TrovitPageData";
import {connect} from "../../../../common/ts/connect";
import {ListingsSubscriber} from "../../serp/subscribers/ListingsSubscriber";
import {ToggleDescription} from "../../serp/subscribers/ToggleDescription";
import {ListingVisited} from "../../serp/subscribers/ListingVisited";
import {ConsentCookieIsAlreadySetEvent, PageLoadedEvent,} from "../../../../common/ts/events/Events";
import {EventBus} from "../../../../common/ts/events/EventBus";
import Sticky from "../../serp/components/Sticky";
import PointsOfCapture from "../../serp/components/retention/pointsOfCapture/PointsOfCapture";
import {GoogleOneTapSubscriber} from "../../serp/subscribers/GoogleOneTapSubscriber";
import webPushManager from "../../serp/components/retention/webPush/webPushManager";
import ConsentSubscriber from "../../serp/subscribers/ConsentSubscriber";
import {isConsentCookieSet, isDidomiConsentCookieSet} from "../../../../common/ts/components/core/ConsentCookie";
import PageGallery from "../../../../common/ts/components/PageGallery";
import {LocalStorageWrapper} from "../../../../common/ts/LocalStorageWrapper";
import tracking from "../../../../common/ts/core/tracking";
import http from "../../../../common/ts/core/http";
import {MiniSerp} from "../../miniSerp/MiniSerp";
import {MiniSerpPagination} from "../../miniSerp/MiniSerpPagination";

const eventBus: EventBus = EventBus.getInstance();
eventBus.subscribeWithId(
    PageLoadedEvent.TYPE,
    {
        id: 'trovit-publisher-page-loaded-subscriber',
        callback: (event) => {
            const pageData: TrovitSerpData = (event as PageLoadedEvent<TrovitSerpData>).payload;
            connect(() => {
                dom.init();
                location.init();
                http.init();
                tracking.init();
                serviceContainer.get(ListingsSubscriber.name).init(pageData);
                serviceContainer.get(ToggleDescription.name).init();
                serviceContainer.get(ListingVisited.name).init();
                serviceContainer.get(Sticky.name).init();
                serviceContainer.get(PointsOfCapture.name).init(pageData);
                serviceContainer.get(GoogleOneTapSubscriber.name).init(pageData);
                webPushManager.init(pageData);
                serviceContainer.get(ConsentSubscriber.name).init(pageData);
            });

            if (isDidomiConsentCookieSet() || isConsentCookieSet()) {
                eventBus.emit(new ConsentCookieIsAlreadySetEvent());
            }
            new PageGallery(".swiper-container:has(.swiper-wrapper)");
            new LocalStorageWrapper().setItem("lastSerpUrl", decodeURIComponent(window.location.href));
            new MiniSerp().init();
            document
                .querySelectorAll<HTMLElement>(MiniSerpPagination.MINI_SERP_UNITS_CONTAINER_SELECTOR)
                .forEach(miniSerpUnitsContainer => {
                    new MiniSerpPagination({miniSerpUnitsContainer}).init();
                });
        }
    }
)
